import { render, staticRenderFns } from "./OrderTypeModal.vue?vue&type=template&id=0399bbbc"
import script from "./OrderTypeModal.vue?vue&type=script&lang=js"
export * from "./OrderTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports